import { YieldFetcher } from '../../types'

/**
 * Solv BTC+ stats. `baseApy` / `rewardApy` are already **percent**
 * values (e.g. "3.02"), so they are summed and used directly as an APR
 * percent — no fraction scaling. Other SolvBTC products (SolvBTC,
 * xSolvBTC) have no comparable public APR feed.
 */
const BTCPLUS_STATS_URL = 'https://api.solvprotocol.org/btcplus/stats'

export const solvBtcPlusFetcher: YieldFetcher = {
  label: 'BTC+',
  fetch: async () => {
    const res = await fetch(BTCPLUS_STATS_URL, {
      headers: { accept: 'application/json' },
    }).then((r) => r.json())
    const base = Number(res?.baseApy)
    const reward = Number(res?.rewardApy)
    const apr =
      (Number.isFinite(base) ? base : 0) +
      (Number.isFinite(reward) ? reward : 0)
    // Canonical token-list assetGroup (see stcelo.ts) — drives the lending join.
    return { SOLVBTCPLUS: apr }
  },
}
